import { PLACEHOLDER_URL } from './deviation-card.constants'
import { StyledDeviationCard } from './deviation-card.styles'
import type { DeviationCardProps } from './deviation-card.types'

export function DeviationCard({
  date,
  description,
  imageUrl,
  onClick,
  title,
  ...props
}: DeviationCardProps): JSX.Element {
  return (
    <StyledDeviationCard
      header={title}
      subheader={date}
      onTdsClick={onClick}
      bodyImg={imageUrl || PLACEHOLDER_URL}
      bodyImgAlt='A deviation'
      {...props}
    >
      {description}
    </StyledDeviationCard>
  )
}
